'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Spinner = require('../shapes/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselLoading = function CarouselLoading(_ref) {
  var size = _ref.size;
  return _react2.default.createElement(
    'div',
    {
      className: 'item active',
      style: {
        backgroundColor: _colors.silver,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      } },
    _react2.default.createElement(
      'div',
      { style: { height: size / 4 } },
      _react2.default.createElement(_Spinner2.default, { size: size / 4 })
    )
  );
};

CarouselLoading.propTypes = {
  size: _propTypes2.default.number
};

exports.default = CarouselLoading;